/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useEffect, useState } from 'react';
import { Box, Grid, IconButton, Typography, Button, Card, CardContent } from '@mui/material';
import { withTheme } from '@emotion/react';
import { grey } from '@mui/material/colors';
import { KeyboardArrowDown } from '@mui/icons-material';
import { Loader } from 'modules/common/components';
import { useDispatch, useSelector } from 'react-redux';
import { configureHotelRoomsActions } from 'modules/hotel-configuration/slice';
import { selectLoader } from 'modules/hotel-configuration/selectors';
import { selectOrganizationId } from 'modules/common/auth/selectors';
import HotelsGrid from '../hotels-table';
import AddHotelFormDialog from '../add-hotel';
/**
 * Main view for hotel configuration configuration layout
 * @param {*} theme
 * @returns
 */
const HotelRoomConfigurationView = ({ theme }) => {
  const dispatch = useDispatch();
  //
  const loading = useSelector(selectLoader);
  const organizationId = useSelector(selectOrganizationId);
  //
  const [open, setOpen] = useState(false);
  // get hotel room configurations
  useEffect(() => {
    dispatch(configureHotelRoomsActions.configureHotelRooms({ organizationId }));
  }, [dispatch]);
  // position scrolling
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  //
  return (
    <Loader loading={loading}>
      <Box>
        <Grid className="sub-title-event-config" item padding={5}>
          <Typography variant="h2">Configure Hotel Rooms</Typography>
          <Grid item container direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body2" sx={{ color: grey[500] }}>
              Last updated on: Thu, 11th Aug 2022 at 12:12
            </Typography>
            <Grid item container direction="row" justifyContent="flex-end" alignItems="center">
              <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
                Add new
              </Button>
              <Typography
                variant="body2"
                sx={{
                  color: grey[500],
                  paddingLeft: 10,
                }}
              >
                Today
              </Typography>
              <IconButton>
                <KeyboardArrowDown />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
        <Card>
          <CardContent
            sx={{
              backgroundColor: theme.palette.background.default,
            }}
          >
            <Grid container spacing={2}>
              <HotelsGrid />
            </Grid>
          </CardContent>
          <AddHotelFormDialog open={open} onClose={() => setOpen(false)} />
        </Card>
      </Box>
    </Loader>
  );
};
//
export default withTheme(HotelRoomConfigurationView);
